import { createFileRoute } from "@tanstack/react-router";
import ClientePage from "@/components/ClientePage";

export const Route = createFileRoute("/cliente")({
  component: ClientePage,
});
